import { useCallback, useEffect, useState } from "react";
import { KYDPixelSettingsUpdate } from "@common/interfaces/KYDEvent";
import actions, { DisplayOrganizationMarketing } from "../../actions";
import { useDialog } from "../../Common/Dialog";
import { useLoading } from "./form";

export const useOrganizationMarketingSettings = () => {
  const [organization, setOrganization] =
    useState<DisplayOrganizationMarketing | null>(null);
  const [loading, setLoading] = useLoading<{ organization: boolean }>({
    organization: false,
  });
  const dialog = useDialog();

  const fetchSettings = useCallback(
    async (silent?: boolean) => {
      if (!silent) {
        setLoading("organization", true);
      }

      try {
        const settings = await actions.ADMIN.fetchOrganizationMarketing();
        setOrganization(settings);
        return settings;
      } catch (err) {
        dialog({ text: err.message });
        return null;
      } finally {
        setLoading("organization", false);
      }
    },
    [dialog, setLoading]
  );

  const updatePixels = useCallback(
    async (pixels: KYDPixelSettingsUpdate[]) => {
      try {
        await actions.ADMIN.updateOrganizationPixels({ pixels });
        await fetchSettings(true);
        return true;
      } catch (err) {
        dialog({ text: err.message });
        return false;
      }
    },
    [dialog, fetchSettings]
  );

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  return {
    organization,
    loading: {
      organization: loading.organization as boolean,
    },
    refetch: fetchSettings,
    updatePixels,
  };
};
